<p-dialog [visible]="visible" (visibleChange)="visibleChange.emit($event)" [modal]="true"
  [header]="title" [draggable]="false" [resizable]="false"
  [style]="{ width: 'min(880px, 94vw)' }" [breakpoints]="{ '860px': '96vw' }"
  styleClass="master-create-dialog">
  <section class="master-dialog-body">
    <aside class="master-dialog-summary">
      <div class="summary-icon"><i [class]="icon"></i></div>
      <div><small>Field Work setup</small><h3>{{ summaryTitle }}</h3><p>{{ summaryCopy }}</p></div>
      <div class="master-dialog-facts">
        <div><span>Configuration</span><strong>{{ title.replace('Add ', '') }}</strong></div>
        <div><span>Scope</span><strong>Current company</strong></div>
      </div>
    </aside>

    <form class="master-dialog-form" (ngSubmit)="submit()">
      <div class="dialog-error master-wide-field" *ngIf="validationError || error">
        <i class="pi pi-exclamation-circle"></i><span>{{ validationError || error }}</span>
      </div>

      <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'role'">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
            <p-iftalabel><input id="fieldRoleCode" pInputText name="roleCode" [(ngModel)]="roleForm.roleCode">
              <label for="fieldRoleCode">Role code *</label></p-iftalabel></p-inputGroup>
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
            <p-iftalabel><input id="fieldRoleName" pInputText name="roleName" [(ngModel)]="roleForm.roleName">
              <label for="fieldRoleName">Role name *</label></p-iftalabel></p-inputGroup>
          <p-inputGroup class="master-wide-field"><p-inputGroupAddon><i class="pi pi-users"></i></p-inputGroupAddon>
            <p-iftalabel><input id="fieldRoleCategory" pInputText name="workerCategory" [(ngModel)]="roleForm.workerCategory">
              <label for="fieldRoleCategory">Worker category</label></p-iftalabel></p-inputGroup>
          <p-inputGroup class="master-wide-field"><p-inputGroupAddon><i class="pi pi-award"></i></p-inputGroupAddon>
            <p-iftalabel><p-multiSelect inputId="fieldRoleCapabilities" name="mandatoryCapabilities" [(ngModel)]="roleCapabilityIds"
              [options]="capabilities" optionLabel="capabilityName" optionValue="fieldCapabilityId"
              [filter]="true" appendTo="body" styleClass="w-full"></p-multiSelect>
              <label for="fieldRoleCapabilities">Mandatory capabilities</label></p-iftalabel></p-inputGroup>
        </ng-container>

        <ng-container *ngSwitchCase="'capability'">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
            <p-iftalabel><input id="fieldCapabilityCode" pInputText name="capabilityCode" [(ngModel)]="capabilityForm.capabilityCode">
              <label for="fieldCapabilityCode">Capability code *</label></p-iftalabel></p-inputGroup>
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-award"></i></p-inputGroupAddon>
            <p-iftalabel><input id="fieldCapabilityName" pInputText name="capabilityName" [(ngModel)]="capabilityForm.capabilityName">
              <label for="fieldCapabilityName">Capability name *</label></p-iftalabel></p-inputGroup>
          <p-inputGroup class="master-wide-field"><p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
            <p-iftalabel><input id="fieldCapabilityCategory" pInputText name="capabilityCategory" [(ngModel)]="capabilityForm.capabilityCategory">
              <label for="fieldCapabilityCategory">Capability category</label></p-iftalabel></p-inputGroup>
        </ng-container>

        <ng-container *ngSwitchCase="'proficiency'">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
            <p-iftalabel><input id="fieldProficiencyCode" pInputText name="levelCode" [(ngModel)]="proficiencyForm.levelCode">
              <label for="fieldProficiencyCode">Level code *</label></p-iftalabel></p-inputGroup>
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-chart-line"></i></p-inputGroupAddon>
            <p-iftalabel><input id="fieldProficiencyName" pInputText name="levelName" [(ngModel)]="proficiencyForm.levelName">
              <label for="fieldProficiencyName">Level name *</label></p-iftalabel></p-inputGroup>
          <p-inputGroup class="master-wide-field"><p-inputGroupAddon><i class="pi pi-sort-numeric-up"></i></p-inputGroupAddon>
            <p-iftalabel><p-inputNumber inputId="fieldProficiencyRank" name="levelRank" [(ngModel)]="proficiencyForm.levelRank" [min]="0" [useGrouping]="false"></p-inputNumber>
              <label for="fieldProficiencyRank">Ordered rank *</label></p-iftalabel></p-inputGroup>
        </ng-container>

        <ng-container *ngSwitchCase="'equipment-category'">
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
            <p-iftalabel><input id="equipmentCategoryCode" pInputText name="categoryCode" [(ngModel)]="categoryForm.categoryCode">
              <label for="equipmentCategoryCode">Category code *</label></p-iftalabel></p-inputGroup>
          <p-inputGroup><p-inputGroupAddon><i class="pi pi-wrench"></i></p-inputGroupAddon>
            <p-iftalabel><input id="equipmentCategoryName" pInputText name="categoryName" [(ngModel)]="categoryForm.categoryName">
              <label for="equipmentCategoryName">Category name *</label></p-iftalabel></p-inputGroup>
          <p-inputGroup class="master-wide-field"><p-inputGroupAddon><i class="pi pi-barcode"></i></p-inputGroupAddon>
            <p-iftalabel><p-select inputId="equipmentTrackingMode" name="trackingMode" [(ngModel)]="categoryForm.trackingMode"
              [options]="[{ label: 'Serialized', value: 'SERIALIZED' }, { label: 'Pooled', value: 'POOLED' }]"
              optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
              <label for="equipmentTrackingMode">Tracking mode *</label></p-iftalabel></p-inputGroup>
        </ng-container>
      </ng-container>
    </form>
  </section>
  <ng-template pTemplate="footer"><div class="master-dialog-footer">
    <p-button label="Reset" icon="pi pi-refresh" severity="secondary" [outlined]="true" (onClick)="reset()"></p-button>
    <span class="footer-spacer"></span>
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" [disabled]="saving" (onClick)="close()"></p-button>
    <p-button [label]="submitLabel" icon="pi pi-plus" [loading]="saving" (onClick)="submit()"></p-button>
  </div></ng-template>
</p-dialog>
